  <mat-card class="mat-elevation-z2" fxFlex="90">
    <mat-card-content style="background-color: #fffff8;">
          <div *ngIf="responseObjs$ | async as responseObjs" class="response__fiche">
            <div fxFlex="80" fxLayout="column" fxLayoutGap="10px">
              <div *ngIf="response" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayoutAlign="start center">
                  Référence de la demande : {{response.reference}}<br/>
                  Date  de dernière mise à jour : {{response?.dt_updated|date: 'dd/MM/yyyy'}}<br/>
                  Demandeur : {{response?.user_obj?.first_name}} {{response?.user_obj?.last_name}}
                  ({{response?.user_obj?.email_pro}})
                </div>
              </div>
              <div fxLayout="column">
                <mat-card class="mat-elevation-z3 top__form" fxFlex="100">
                  <mat-card-title fxLayoutAlign="center">
                    <div class="form__title">
                      {{formName}}
                    </div>
                  </mat-card-title>
                </mat-card>
                <div *ngFor="let resp of responseObjs;let i = index" class="block__container">
                  <ng-container *ngIf="resp[0]">
                    <div class="block__title">
                      <h2><span>{{ getBlockPrefixDesign(i) }}</span> {{resp[0].block_name}}</h2>
                    </div>
                    <mat-card class="mat-elevation-z0 reponse__card">

                      <ng-container *ngIf="getConditionBLock(resp) as conditionBlock">
                        <div *ngIf="conditionBlock?.is_active">
                          <label>{{ conditionBlock?.condition }}</label>
                          <mat-radio-group [value]="getConditionBLockValue(resp)?.display" class="block__condition" disabled>
                            <mat-radio-button [value]="true">{{ conditionBlock?.satisfy }}</mat-radio-button>
                            <mat-radio-button [value]="false">{{ conditionBlock?.other }}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="getConditionBLockValue(resp)?.display">
                        <div *ngFor="let f of resp | orderBy: 'order'" class="response__container">
                          <div class="response">
                            <mat-card-title class="response__label">{{getLabel(f)}}</mat-card-title>
                            <!-- Fichier -->
                            <div *ngIf="f.field?.options_obj?.controlType === fieldType.TypeFile">
                              <p class="class__value" *ngIf="f.file && f.value">
                                <button mat-icon-button class="download__button"
                                        color="accent"
                                        inline=true
                                        [matTooltip]="'Télécharger le fichier ' + f.value"
                                        (click)="downloadFile(f)"
                                >
                                  <mat-icon class="download__icon" [attr.data-cy]="'icon-response-fiche-'+f.id">file_download</mat-icon>
                                </button>
                                {{getValue(f) || "---"}}
                                <button mat-icon-button class="download__button" *ngIf="getFileExtension(f.file)"
                                        color="accent"
                                        inline=true
                                        [matTooltip]="'Voir le fichier ' + f.value"
                                        (click)="visualiser([f])"
                                >
                                  <mat-icon class="view__icon" [attr.data-cy]="'icon-response-fiche-'+f.id">visibility</mat-icon>
                                </button>
                              </p>
                            </div>
                            <!-- textarea : on affiche le HTML -->
                            <p class="class__value" *ngIf="f.field?.options_obj?.controlType === fieldType.TypeTextarea"
                               [innerHTML]="getValue(f) | newline"></p>
                            <p class="class__value__label" *ngIf="f.field?.options_obj?.controlType === fieldType.TypeLabel"
                               [innerHTML]="getValueLabel(f)|safeHtml"></p>
                            <!-- type avis -->
                            <app-avis-fiche *ngIf="f.field?.options_obj?.controlType === fieldType.TypeAvis"
                                            [item]="getValue(f)"
                                            [response_state]="response?.state"
                                            [individu]="individu" [response]="response"></app-avis-fiche>
                            <!-- autre type -->
                            <p class="class__value" *ngIf="!filterTypeOfField(f)">
                              {{getValue(f) || "---"}}
                            </p>
                          </div>
                        </div>
                      </ng-container>

                    </mat-card>

                  </ng-container>
                </div>

              </div>
            </div>
          </div>
    </mat-card-content>
  </mat-card>
